window.whalewisdom.MutualFundTables = {
    show_combined:true,
    selected_filing:null,
    columns:[

    ],
    init:function () {

        var mutual_fund_columns=[
            { field: 'repPdDate', title: 'Period of Report', sortable: true, index: 'repPdDate'},
          //  { field: 'lei', title: 'LEI', sortable: true, index: 'lei'},
            //{ field: 'cusip', title: 'CUSIP', sortable: true, index: 'cusip'},
            { field: 'balance', title: 'Balance', sortable: true, index: 'balance',formatter: whalewisdom.Stock.format_number},
            { field: 'units', title: 'Units', sortable: true, index: 'units'},
            { field: 'name', title: 'Name', sortable: true, index: 'name'},
            { field: 'symbol', title: 'Ticker', sortable: true, index: 'ticker'},
            { field: 'title', title: 'Title', sortable: true, index: 'title'},
            { field: 'der_info', title: 'Additional Info', sortable: true, index: 'der_info',sortable:false},
            {
                field: 'invCountry',
                sortable: true,
                index: 'invCountry',
                title: 'Country',
                firstsortorder: 'desc',
            },
            {
                field: 'valUSD',
                sortable: true,
                index: 'valUSD',
                title: 'Value (USD)',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_money
            },
            {
                field: 'pctVal',
                title: '% Value',
                sortable: true,
                firstsortorder: 'desc',
                index: 'pctVal',
                formatter: whalewisdom.Stock.format_percent
            },
            {
                field: 'payoffProfile',
                title: 'Payoff Profile',
                sortable: true,
                firstsortorder: 'desc',
                index: 'payoffProfile',
            },
            {
                field: 'assetCat',
                title: 'Asset Category',
                sortable: true,
                firstsortorder: 'desc',
                index: 'assetCat',
            }

        ]
        var holdings_columns=[
            { field: 'filing_period', title: 'Period of Report', sortable: true, index: 'filing_period'},


            { field: 'name', title: 'Name', sortable: true, index: 'name'},
            { field: 'symbol', title: 'Ticker', sortable: true, index: 'ticker',formatter: whalewisdom.MutualFundTables.symbol_formatter},
            { field: 'title', title: 'Title', sortable: true, index: 'title'},
            { field: 'security_type', title: 'Type', sortable: true, index: 'security_type'},
            { field: 'position_change_type', title: 'Change', sortable: true, index: 'position_change_type'},
            { field: 'der_info', title: 'Additional Info', sortable: true, index: 'der_info',sortable:false},
            {
                field: 'current_shares',
                sortable: true,
                index: 'current_shares',
                title: 'Shares Held<br/>or Principal Amt',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_number
            },
            {
                field: 'current_mv',
                sortable: true,
                index: 'current_mv',
                title: 'Market Value',
                firstsortorder: 'desc',
                formatter: whalewisdom.Stock.format_money
            },
            {
                field: 'current_percent_of_portfolio',
                title: '% of<br/>Portfolio',
                sortable: true,
                firstsortorder: 'desc',
                index: 'current_percent_of_portfolio',
                formatter: whalewisdom.Stock.format_percent
            },
            {
                field: 'previous_percent_of_portfolio',
                title: 'Previous<br/>% of Portfolio',
                sortable: true,
                firstsortorder: 'desc',
                index: 'previous_percent_of_portfolio',
                formatter: whalewisdom.Stock.format_percent
            },
            {
                field: 'current_ranking',
                title: 'Rank',
                sortable: true,
                firstsortorder: 'desc',
                index: 'current_ranking',
            },
            {
                field: 'shares_change',
                title: 'Change in<br/>Shares',
                sortable: true,
                firstsortorder: 'desc',
                index: 'shares_change',
                formatter: whalewisdom.Stock.change_formatter,
            },
            {
                field: 'percent_change',
                title: '% Change',
                sortable: true,
                firstsortorder: 'desc',
                //   width: 95,
                index: 'percent_change',
                formatter: whalewisdom.Stock.percent_change_formatter
            },
            {
                field: 'long_short',
                title: 'Long/Short',
                sortable: true,
                firstsortorder: 'desc',
                index: 'long_short',
            },
          //  { field: 'lei', title: 'LEI', sortable: true, index: 'lei'},
           // { field: 'cusip', title: 'CUSIP', sortable: true, index: 'cusip'},
        ];
        jQuery('.cmd-refresh-mf').click(whalewisdom.MutualFundTables.refresh);
        $('#mutual_fund_holdings_table').bootstrapTable({
            url: whalewisdom.MutualFundTables.build_mutual_fund_url(),
            sidePagination: 'server',
            pagination:true,
            paginationVAlign: 'both',
            onLoadError:function(arg1,arg2){
                $('#mutual_fund_holdings_table').bootstrapTable('updateFormatText', 'NoMatches', arg2.responseText);
            },
            sortName:'name',
            stickyHeader: true,
            sortOrder:'asc',
            showJumpto:true,
            pageSize:25,
            showColumns:true,
            pageList:[10,25,50],
            totalField:'records',
            columns: holdings_columns
        });
        jQuery('#cmd-mf-export').click(whalewisdom.MutualFundTables.export_to_excel);
        jQuery('#cmd-mf-tsv').click(whalewisdom.MutualFundTables.export_to_excel_tsv);
        jQuery('#cmd-mf-xlsx').click(whalewisdom.MutualFundTables.export_to_excel_xlsx);

    },
    refresh:function (e) {
        jQuery("#mutual_fund_holdings_table").bootstrapTable('refresh',{url:whalewisdom.MutualFundTables.build_mutual_fund_url()});

        //jQuery("#listings_table").jqGrid('setGridParam', {url:whalewisdom.Stock.build_url()}).trigger("reloadGrid");
    },
    format_money:function(cellvalue,record){
        if (!cellvalue || isNaN(cellvalue))
            return "";
        return  numbro(cellvalue).formatCurrency({thousandSeparated:true,mantissa:0});
        //return numbro(cellvalue).format('($0,0a');
    },
    format_number:function(cellvalue,record){
        if (!cellvalue ||isNaN(cellvalue))
            return "";
        return numbro(cellvalue).format({thousandSeparated:true,negative:'parenthesis'});
        // return numbro(cellvalue).format('(0,0a');
    },
    format_percent:function(cellvalue,record){
        if (!cellvalue ||isNaN(cellvalue))
            return "";
        return numbro(cellvalue).format('0.00');
    },

    build_change_filter:function () {
        var outArr = [];
        var filters = jQuery('.filter-change');
        filters.filter(':checked').each(function () {
            outArr.push(jQuery(this).val());
        });
        return outArr.join(",");
    },
    ranking_formatter:function (cellvalue, record) {
        var cell = record.ranking;
        if (!record.ranking)
            return '';
        if (record.ranking === 999999)
            cell = 'Sold All';

        return cell;
    },
    ownership_formatter:function (cellvalue,  record) {
        var cell = record.percent_ownership;
        if (!cell || cell=='No Data' || cell=='N/A' || cell=='null'){
            return "";
        }
        else{
            cell=parseFloat(record.percent_ownership).toFixed(4)+"%";
        }

        return cell;
    },
    symbol_formatter: function (cellvalue, record) {
        var url = window.location.href
        var href = null
        if (url.indexOf('#') >= 0) {
            url = url.substring(0, url.indexOf('#'))
        }

        href = url.split('/')
        var cell = '<a href="/stock/' + record.stock_permalink + '" title="' + record.name + '">' + (record.symbol ? record.symbol.toUpperCase() : '')

        cell += '</a>'
        return cell
    },

    build_mutual_fund_url:function(){
        var stock_id= whalewisdom.Stock.stock_id;
        var quarter_id=$('#edgar_submission_id').val();
        return '/mutual_fund/holdings?id=' + quarter_id+"&stock_id="+stock_id;
    },
    update_query_url:function () {

        jQuery("#mutual_fund_holdings_table").bootstrapTable('refresh',{url:whalewisdom.MutualFundTables.build_mutual_fund_url()});
        //jQuery("#listings_table").jqGrid('setGridParam', {url:whalewisdom.Stock.build_url()});   //.trigger("reloadGrid");
    },
    export_to_excel:function () {
        if (!whalewisdom.Utilities.isLoggedIn()){
            whalewisdom.Utilities.show_alert("Please Log In First",
                "Please create an account or log into your existing account first. ");
            return;
        }

        var url = whalewisdom.MutualFundTables.build_mutual_fund_url().replace("holdings", "holdings_csv");
        window.location = url;
    },
    export_to_excel_tsv: function () {
        if (!whalewisdom.Utilities.isLoggedIn()){
            whalewisdom.Utilities.show_alert("Please Log In First",
                "Please create an account or log into your existing account first. ");
            return;
        }

        var url = whalewisdom.MutualFundTables.build_mutual_fund_url().replace("holdings", "holdings_tsv");
        window.location = url;
    },
    export_to_excel_xlsx: function () {
        if (!whalewisdom.Utilities.isLoggedIn()){
            whalewisdom.Utilities.show_alert("Please Log In First",
                "Please create an account or log into your existing account first. ");
            return;
        }

        var url = whalewisdom.MutualFundTables.build_mutual_fund_url().replace("holdings", "holdings_xlsx");
        window.location = url;
    },
    filer_formatter:function (cellvalue, record) {
        var href = window.location.href.split("/");
        var cell = '<a href="/filer/' + record.permalink + '" title="' + record.name + '">' + record.name;
        // if (record.security_type != "SH")
        //     cell += "<span style='font-weight:bold;'>(" + record.security_type + ")</span>";
        cell += '</a>';
        if (record.security_type == "PRN")
            cell += "<span style='font-weight:bold;' title='PRN - principal amount on convertible debt securities'>(" + record.security_type + ")</span>";
        else if (record.security_type !='SH')
            cell += "<span style='font-weight:bold;'>(" + record.security_type + ")</span>";
        return cell;
    },
    series_formatter:function (cellvalue, record) {
        var href = window.location.href.split("/");
        var cell = '<a target="_blank" href="/dashboard2/mutual_fund/mutual_fund_holdings_view/' + record.seriesLei + '" title="' + record.seriesName + '">' + record.seriesName+"</a>";
        return cell;
    },
    fund_formatter:function (cellvalue, record) {
        var href = window.location.href.split("/");
        var cell = '<a target="_blank" href="/dashboard2/mutual_fund/mutual_fund_view/' + record.filer_permalink + '" title="' + record.regName + '">' + record.regName+"</a>";
        return cell;
    },
    history_formatter:function (cellvalue, record) {
        var href = window.location.href.split("/");
        var cell = '<a title="View Filer Ownership History" alt="View Filer Ownership History" class="history-link" href="' +
            '/filer/stock_history/' + record.permalink + "/" + href[href.length - 1] + '/' + '"></a>';

        return cell;
    },
    change_formatter:function (cellvalue, record) {
        var c = "";
        if (!record.shares_change){
            return "<span class=\"" + c + "\"></span>";
        }
        var desc = Math.abs(record.shares_change);
        desc = whalewisdom.Utilities.round_currency(desc);
        if (record.shares_change == 0) {
            desc = "No Change";
        }
        else if (record.shares_change < 0) {
            c = "decreasing";
        }
        else {
            c = "increasing";
        }
        return "<span class=\"" + c + "\">" + desc + "</span>";
    },

}
jQuery(function () {
    whalewisdom.MutualFundTables.init();
});